export const en = {
    'test': 'test'
};
export const fr = {
    'test': 'testfr'
};